import core from './core';
import { Options } from './product-options';
import ImageUpdater from './views/product-image-updater';
import { DeviceManager, TABLET } from './DeviceManager';
import { HotfoilEffectBuilder } from '../builders/HotfoilEffectBuilder';
import { getUrlParams } from '../helpers/handle-url';
import { assetsUrlReplace } from '../helpers/assets-image-url-rewriter';
import { EnhanceEcommerce } from '../helpers/EnhanceEcommerce';
import { Glossary } from '../helpers/Glossary';

const ProductList = core.extend({
	constructor(options) {
		this.config = {
			selectors: {
				items: '.js-category-item:not(.js-fake-product)',
				toProductLink: '.js-to-product',
				trackClick: '.js-track-click',
			},
		};
		this.$ = {};
		this.deviceManager = new DeviceManager();
		this.$.holder = jQuery(options.holder);
		this.wishListComponents = options.wishListComponents;
		this.loadObjects(options.holder);
		jQuery.extend(true, this.config, options || {});
		this.init();
	},

	init() {
		this.setupProductOptions();

		this.attachEvents();
	},

	setupProductOptions() {
		this.tiles = [];

		this.$.items.each((ind, el) => {
			const scope = jQuery(el);
			const productJSON = JSON.parse(scope.find('.js-product-data').html());
			const noColors = !_.filter(
				productJSON.concreteProducts,
				(product) => product.productOptions.color && product.productOptions.color.length
			).length;
			const productPicture = scope.find('.js-product-picture');

			scope.find('.overwrite-data').each(function () {
				if (productJSON.categoryPreConfig) {
					_.extend(productJSON.categoryPreConfig, JSON.parse(jQuery(this).html()));
				}
			});

			let hotfoil = HotfoilEffectBuilder.getHotfoil(productJSON.categoryPreConfig.refinement);

			const hotfoilBuilder = new HotfoilEffectBuilder(hotfoil);

			if (productJSON.categoryPreConfig.tag === Glossary.TAG_SKU) {
				productJSON.categoryPreConfig.diecut = Glossary.RIBBON_AND_TAG_DIECUT;
			}

			const wishListButton = this.wishListComponents.getWishListButton({
				elementsList: el.querySelectorAll('.js-add-to-wishlist'),
				data: productJSON,
			});

			const option = new Options({
				json: productJSON,
				opts: {
					el: scope,
					control: '.option',
					event: DeviceManager.hasOrientation() ? 'click touchstart' : 'mouseenter',
					mode: this.config.pageType,
					actionElement: '.js-action-element',
					activeClass: 'active',
					wishlistButton: wishListButton,
					imageUpdater: new ImageUpdater({
						mainImg: productPicture,
						data: {
							mode: this.config.pageType,
							noColors,
						},
					}),
					toProductLink: this.config.selectors.toProductLink,
					hotfoilBuilder,
					hotfoilEffect: hotfoilBuilder.build(productPicture[0]),
				},
			});

			this.tiles.push({ instance: option });

			const overlayImage = el.querySelector('.js-PortraitCategoryItem-overlay');

			if (overlayImage) {
				option.subscribe('options:format-color:changed', (event, data) => {
					const product = productJSON.concreteProducts.find((product) => product.format === data.format);

					if (product && product.overlayImages[data.color]) {
						const overlayImageUrl = product.overlayImages[data.color];

						overlayImage.setAttribute('src', overlayImageUrl);
						overlayImage.classList.remove('is-hidden');
					} else {
						overlayImage.classList.add('is-hidden');
						overlayImage.setAttribute('src', '');
					}
				});
			}
		});
	},

	updateTiles(response) {
		const isNewProductList = response.filters || response.pagination;

		this.renderProducts(response, isNewProductList);

		this.$.items = jQuery(this.config.selectors.items);

		if (isNewProductList) {
			this.wishListComponents.clearButtonList();
		}

		this.setupProductOptions();
	},

	renderProducts(response, isNewProductList) {
		if (isNewProductList) {
			this.$.holder.html(response.data);
		} else {
			this.$.holder.append(response.data);
		}
	},

	attachEvents() {
		jQuery(document).on('click', this.config.selectors.trackClick, (e) => {
			const target = jQuery(e.target);

			if (target.hasClass('js-custom-option')) {
				return;
			}

			e.preventDefault();

			if (this.deviceManager.getCurrentState() <= TABLET && target.parents('.options').length) {
				return;
			}

			const { currentTarget } = e;
			const parentNode = currentTarget.closest('.js-category-item');
			const sku = parentNode.getAttribute('data-sku');
			const tilePosition = parentNode.getAttribute('data-grid-position');
			const productDetailUrl = currentTarget.href;
			const productJSON = JSON.parse(parentNode.querySelector('.js-product-data').innerHTML);

			this.trackOnProductClick(sku, tilePosition, productDetailUrl, productJSON);
		});
	},

	trackOnProductClick(sku, tilePosition, pdpUrl, productJSON) {
		const customOptions = getUrlParams({}, pdpUrl.split('?')[1] || '');

		EnhanceEcommerce.trackProductClick(productJSON, categoryName, tilePosition, customOptions, pdpUrl);
	},
});

export default ProductList;
